const THRESHOLD_KEY_LABELS = {
  monitored_value_limit: 'Limite de valor monitorado',
  monitored_value_margin: 'Margem de valor monitorado',
  operations_spoof_min_count: 'Quantidade mínima de operações suspeitas de spoofing',
  operations_spoof_min_value: 'Valor mínimo para operações suspeitas de spoofing',
  immediate_debit_time_window_minutes: 'Janela de tempo para débito imediato (minutos)',
  immediate_debit_value_delta: 'Diferença de valor para débito imediato',
  transactions_incompatible_min_value: 'Valor mínimo para transações em horário incompatível',
  usual_payments_outside_area_min_count: 'Quantidade mínima de pagamentos fora da área usual',
  group_i_fragmentation_window_hours: 'Janela de fragmentação (horas)',
  group_i_fragmentation_min_count: 'Quantidade mínima de depósitos fragmentados',
  group_i_fragmentation_window_total_min_value: 'Valor total mínimo na janela de fragmentação',
  group_i_quick_transfer_window_minutes: 'Janela de transferência rápida (minutos)',
  group_i_quick_transfer_min_cash_deposits_count: 'Mínimo de depósitos em espécie antes da transferência',
  group_i_quick_transfer_value_delta: 'Tolerância de diferença de valor na transferência rápida',
  group_i_quick_transfer_min_transfer_value: 'Valor mínimo da transferência rápida',
  group_i_withdrawal_window_days: 'Janela de saques abaixo do limite (dias)',
  group_i_withdrawal_min_count: 'Quantidade mínima de saques abaixo do limite',
  group_i_reporting_limit_value: 'Limite de reporte em espécie',
  group_i_pep_cash_deposit_min_value: 'Valor mínimo de depósito em espécie para PEP',
  group_i_luxury_cash_min_value: 'Valor mínimo para operações em espécie de atividade de luxo',
  group_i_large_cash_installments_window_hours: 'Janela de parcelamento de grandes valores em espécie (horas)',
  group_i_large_cash_installments_min_count: 'Quantidade mínima de operações parceladas de alto valor',
  group_i_large_cash_installments_min_total_value: 'Valor total mínimo de operações parceladas de alto valor',
  group_i_large_cash_installments_max_unit_value: 'Valor máximo por operação parcelada de alto valor',
  group_i_multi_origin_credits_window_hours: 'Janela de créditos eletrônicos de múltiplas origens (horas)',
  group_i_multi_origin_credits_min_count: 'Quantidade mínima de créditos eletrônicos',
  group_i_multi_origin_credits_min_origins_count: 'Quantidade mínima de origens distintas de crédito',
  group_i_small_denomination_window_hours: 'Janela de operações com indício de pequenas cédulas (horas)',
  group_i_small_denomination_min_count: 'Quantidade mínima de operações com indício de pequenas cédulas',
  group_i_small_denomination_min_total_value: 'Valor total mínimo de operações com indício de pequenas cédulas',
  group_i_same_day_withdrawal_min_count: 'Quantidade mínima de saques no mesmo dia',
  group_i_atm_deposit_window_days: 'Janela de depósitos em ATM (dias)',
  group_i_atm_deposit_min_count: 'Quantidade mínima de depósitos em ATM',
  group_i_atm_deposit_max_unit_value: 'Valor máximo por depósito em ATM',
  risk_medium_min_alert_count: 'Quantidade mínima de apontamentos para risco médio',
  risk_high_min_alert_count: 'Quantidade mínima de apontamentos para risco alto',
  risk_medium_min_total_alert_value: 'Valor movimentado mínimo para risco médio',
  risk_high_min_total_alert_value: 'Valor movimentado mínimo para risco alto',
  risk_high_on_high_severity_alert: 'Elevar para risco alto quando houver alerta crítico',
  risk_medium_on_any_alert: 'Elevar para risco médio quando houver qualquer alerta',
};

const RULE_SKIP_REASON_LABELS = {
  client_override: 'Desativada por override do cliente',
  disabled_in_plan: 'Desativada no plano',
  skipped_by_policy: 'Ignorada pela política vigente',
  blocked_by_data: 'Bloqueada por dados insuficientes',
  blocked_due_to_data: 'Bloqueada por dados insuficientes',
  bloqueada_por_dados: 'Bloqueada por dados insuficientes',
};

export const getThresholdKeyLabel = (key) => {
  if (!key) {
    return '-';
  }

  return THRESHOLD_KEY_LABELS[key] || key;
};

export const getRuleSkipReasonLabel = (reason) => {
  if (!reason) {
    return '';
  }

  const normalizedReason = String(reason).trim();
  const [code, detail] = normalizedReason.split(':');
  const normalizedCode = (code || '').trim();
  const normalizedDetail = (detail || '').trim();

  const mappedLabel = RULE_SKIP_REASON_LABELS[normalizedCode];

  if (!mappedLabel) {
    return normalizedReason;
  }

  if (!normalizedDetail) {
    return mappedLabel;
  }

  return `${mappedLabel}: ${normalizedDetail}`;
};

const COAF_GROUP_LABELS = {
  I: 'Grupo I - Operações em espécie',
  II: 'Grupo II - Moeda estrangeira e cartão pré-pago',
  III: 'Grupo III - Cadastro e identificação',
  IV: 'Grupo IV - Movimentações Financeiras Atípicas',
  V: 'Grupo V - Ativos financeiros',
  VI: 'Grupo VI - Crédito no País',
  VII: 'Grupo VII - Agentes públicos e serviços sensíveis',
  VIII: 'Grupo VIII - Consórcio',
  IX: 'Grupo IX - Terrorismo e proliferação',
  X: 'Grupo X - Câmbio e comércio exterior',
  XI: 'Grupo XI - Crédito no exterior',
  XII: 'Grupo XII - Investimento externo direto',
  XIII: 'Grupo XIII - Risco interno e parceiros',
  XIV: 'Grupo XIV - Eleitoral',
  XV: 'Grupo XV - BNDU e ativos não financeiros',
  XVI: 'Grupo XVI - CCME e mercado de câmbio',
  XVII: 'Grupo XVII - Regiões de risco',
  CIRCULAR_3978: 'Circular 3.978 - Art. 49',
};

export const getCoafGroupLabel = (group) =>
  COAF_GROUP_LABELS[String(group || '').toUpperCase()] || `Grupo ${group || '-'}`;
